module.exports = __webpack_public_path__ + "img/chicken_animal_4448_reverse.5d1bcd88.png";